














import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import anime from "animejs";
import Button from "../Button.vue";
import Swal from 'sweetalert2';
import axios from 'axios';
import ContactForm from "../../mixins/ContactForm";

@Component({
  components: {
    Button
  }
})
export default class BuyAHouseForm extends Mixins(ContactForm) {
  $refs!: {
    form: HTMLFormElement;
    content: HTMLElement;
  };

  mounted() {
  }
}
